import { render, staticRenderFns } from "./Dropzone.component.vue?vue&type=template&id=edeb4f46&scoped=true"
import script from "./Dropzone.component.vue?vue&type=script&lang=js"
export * from "./Dropzone.component.vue?vue&type=script&lang=js"
import style0 from "./Dropzone.component.vue?vue&type=style&index=0&id=edeb4f46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edeb4f46",
  null
  
)

export default component.exports